<template>
<div>
	<div class="container">
		<!-- <footer-s></footer-s> -->
		<loginHeader></loginHeader>

		<div class="about">
			<img src="../../assets/img/contact-c.jpg" class="about-sign"/>
			<div class="company" >
				<div class="company-list cont-padding">
					<h1>联系我们</h1>
					<p>非常感谢您使用订房易，如果您有提议、投诉及相关建议，请及时与我们联系，您的参与将帮助我们改进产品及服务。</p>
					<p>公司地址：深圳市罗湖区人民南路3012号天安国际大厦C座25层。</p>
					<p>工作时间：周一至周五（早8点半到晚8点半）</p>
					<p class="pp-padding ">周六（早8点半到晚7点）</p>
					<p class="pp-padding ">周日（早9点半到晚6点）</p>
				</div>

				<div class="company-list">
					<h1>集团电话 </h1>
					<div class="company-contact">
						<div class="left">
							<img src="../../assets/img/phone.png" />
						</div>
						<div class="mail-phone">
							<h1>0755-8236 5588</h1>
						</div>
					</div>

					<div class="company-contact">
						<div class="left">
							<img src="../../assets/img/mail.png" />
						</div>
						<div class="mail-phone">
							<h1>Marketing-2@cnbooking.net  </h1>
						</div>
					</div>

				</div>

				<div class="company-list">
					<h1>客服热线</h1>
					<!-- <div class="company-contact">
						<div class="left">
							注册<br />
							服务
						</div>
						<div class="mail-phone">
							<h1>0755-8231 5186 </h1>
						</div>
		
					</div> -->

					<div class="company-contact">
						<div class="left">
							预订<br />
							服务
						</div>
						<div class="mail-phone">
							<h1>0755-8236 3388 </h1>
						</div>
					</div>

					<div class="company-contact">
						<div class="left">
							团房<br />
							服务
						</div>
						<div class="mail-phone">
							<h1>189 3806 6687 </h1>
						</div>
					</div>


				
				</div>

				<div class="company-list">
					<h1>投诉建议</h1>
					<!-- <div class="company-contact">
						<div class="left">
							网站<br />
							建议

						</div>
						<div class="mail-phone">
							<h1>0755-8231 5229 </h1>
						</div>
					</div> -->
					<div class="company-contact">
						<div class="left">
							质检<br />
							监督

						</div>
						<div class="mail-phone">
							<h1>0755-2588 4156 </h1>
						</div>
					</div>


				</div>

			</div>


		</div>

		<div class="home-footer">
			<div class="home-box home-footer-t">
				<div class="top">
					<div class="left home-contact">
						<h3>了解我们</h3>
						<router-link to="about">关于我们</router-link>
						<router-link to="contact">联系我们</router-link>
						<router-link to="contact">投诉建议</router-link>
						<router-link to="join">诚聘英才</router-link>
						
					</div>
					<div class="middle home-contact">
						<h3>客户须知</h3>
						<router-link to="introduction">预订须知</router-link>
						<router-link to="introduction">协议下载</router-link>
						<router-link to="introduction">教程下载</router-link>
					</div>
					<div class="right home-contact">
						<h3>邮箱地址</h3>
						<a href="#">国内酒店合作 chinahotel-1@cnbooking.net</a>
						<a href="#">国际酒店合作 globalhotel-33@cnbooking.net</a>
						<a href="#">OTA合作 channel-3@cnbooking.net</a>
						<a href="#">旅行社合作 chinahotel-3@cnbooking.net</a>
					</div>
					<div class="right-side home-contact">
						<h3>微信二维码</h3>
						<img src="./../../assets/img/ewm.png" alt="" />
					</div>
					<div class="clear"></div>
				</div>
				<div class="bottom">
					<img src="./../../assets/img/home-footer-logo.png" alt="" />
					<div>
						<h4>Copyright©2013-2017,dingfangyi.com.All rights reserved.</h4>
						<h4>
							<a href="#" style="text-decoration: none; color: #999;">粤ICP备17131089号</a>
							<a target="_blank" href="#" style="text-decoration: none; color: #999; float: right;">
								<img src="./../../assets/img/ga.png" />
								    粤公网安备 44030302000423号
							</a>
						</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
	import FooterS from '../Footer-s.vue'
	import loginHeader from '../loginHeader.vue'
	export default {
        components: { FooterS,loginHeader },
	}
</script>


// WEBPACK FOOTER //
// src/components/info/contact.vue